module.exports = __webpack_public_path__ + "img/logo-smapa.e3d97054.png";